<template>
  <div class="form element js-animation form-additional">
    <div class="title">{{ $t(props.title) }}</div>
    <div class="subtitle_a">{{ $t(props.header) }} </div>
    <div class="subtitle_c"><b>{{ $t(props.reason) }}</b></div>
    <!-- <div class="subtitle_b">
        受付番号 : {{ receiptNumber }}
    </div> -->
    <div class="subtitle_b">
      <slot></slot>
    </div>
    <div class="subtitle_d">
      <b>{{ $t('termsAndConditions.reviewSubmission.contact')}}</b>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
const props = defineProps({
  title: { type: String, default: 'termsAndConditions.reviewSubmission.title' },
  message: String,
  reason: String,
  header: String
})

const receiptNumber = ref('')

const updateReceipt = (newReceiptNumber: string) => {
  receiptNumber.value = newReceiptNumber
}

defineExpose({ updateReceipt })
</script>

<style scoped>

.form-additional {
  top: 78px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;
  color: white;
  padding: 10px;
  background-color: darkred;
  border-radius: 5px;
  text-align: center;
}

.subtitle_c {
  font-size: 25px;
  margin: 5px auto;
  color: black;
  text-align: center;
  width: max-content;
  border-radius: 5px;
  padding: 10px;
  min-width: 100px;
}

.subtitle_d {
  font-size: 20px;
  color: black;
  text-align: right;
}

.form {
  height: 500px;
  margin: 5px !important;
  box-sizing: border-box;
}

/* Desktop */
@media screen and (min-width: 1025px) {
  .subtitle_a {
    font-size: 50px;
    margin: 1px auto;
    color: black;
    text-align: center;
    width: max-content;
    border-radius: 5px;
    padding: 10px;
    min-width: 200px;
  }

  .subtitle_b {
    font-size: 40px;
    margin: 20px auto;
    color: darkred;
    text-align: center;
    width: max-content;
    border-radius: 5px;
    padding: 10px;
    min-width: 200px;
    border: solid 1px darkred;
  }

  .subtitle_c {
    font-size: 25px;
    margin: 5px auto;
    color: black;
    text-align: center;
    width: max-content;
    border-radius: 5px;
    padding: 10px;
    min-width: 100px;
  }

  .subtitle_d {
    font-size: 20px;
    color: black;
    text-align: right;
  }

  .form {
    background-color: #ffffff;
    position: relative;
    z-index: 10;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    box-shadow: -3px 2px 11px 0px #666666;
    border: solid darkred 3px;
    padding: 0 20px;
    color: black;
  }
}

/* Mobile + Tablet + iPad Pro 1024px */
@media screen and (max-width: 1199px) {
  .form {
    height: auto;
    margin: 5px !important;
    min-height: 500px;
    padding-bottom: 30px;
    width: calc(100% - 10px);
  }

.subtitle_a {
    font-size: 25px;
    margin: 50px auto 15px;
    color: black;
    border-radius: 5px;
    padding: 10px;
  }

  .subtitle_b {
    font-size: 20px;
    font-weight: 500;
    margin: 20px auto;
    color: darkred;
    text-align: center;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border: solid 1px darkred;
    overflow-wrap: break-word;
  }

  .subtitle_c {
    font-size: 18px;
    margin: 10px auto;
    padding: 10px 5px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
  }

  .subtitle_d {
    font-size: 16px;
    margin: 20px auto 25px;
    padding: 0 5px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    color: black;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
  }
}

@media screen and (min-width: 992px) {

  .subtitle_a {
    font-size: 50px;
    margin: 1px auto;
    color: black;
    text-align: center;
    width: max-content;
    border-radius: 5px;
    padding: 10px;
    min-width: 200px;
  }

  .subtitle_b {
    font-size: 40px;
    margin: 20px auto;
    color: darkred;
    text-align: center;
    width: max-content;
    border-radius: 5px;
    padding: 10px;
    min-width: 200px;
    border: solid 1px darkred;
  }

  .subtitle_c {
    font-size: 25px;
    margin: 5px auto;
    color: black;
    text-align: center;
    width: max-content;
    border-radius: 5px;
    padding: 10px;
    min-width: 100px;
  }

  .subtitle_d {
    font-size: 20px;
    color: black;
    text-align: right;
  }

  .form {
    background-color: #ffffff;
    position: relative;
    z-index: 10;
    margin: 5px !important;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    box-shadow: -3px 2px 11px 0px #666666;
    border: solid darkred 3px;
    padding: 0 20px;
    color: black;
  }
}

 @media screen and (max-width: 960px) {
  .form {
    height: auto;
    min-height: 500px;
    padding-bottom: 30px;
    box-sizing: border-box;
  }

  .subtitle_a {
    font-size: 25px;
    margin: 50px auto 15px;
    color: black;
    border-radius: 5px;
    padding: 10px;
  }

  .subtitle_b {
    font-size: 20px;
    font-weight: 500;
    margin: 20px auto;
    color: darkred;
    text-align: center;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border: solid 1px darkred;
    overflow-wrap: break-word;
  }

  .subtitle_c {
    font-size: 18px;
    margin: 10px auto;
    padding: 10px 5px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
  }
  .subtitle_d {
    font-size: 16px;
    margin: 20px auto 25px 0;
    padding: 0 5px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    color: black;
    text-align: center;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
  }
}

</style>
